import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';

import { t } from '@lib/translation/helpers';

import { ISnMobilePhoneFormFieldConfig } from '../../interfaces/mobile-phone-form-field-config.interface';
import { ISnMobilePhoneTemplateOptions } from '../../interfaces/mobile-phone-template-options.interface';

@Component({
  selector: 'sn-mobile-phone-form-field',
  templateUrl: './mobile-phone.field-type.html',
  styleUrls: ['./mobile-phone.field-type.scss'],
})
export class SnMobilePhoneFormField extends FieldType<ISnMobilePhoneFormFieldConfig> {
  public readonly defaultOptions: ISnMobilePhoneFormFieldConfig = {
    type: 'mobile-phone',
    templateOptions: {
      label: t('common.mobilePhone'),
      appearance: 'fill',
      floatLabel: 'always',
    },
    validation: {
      messages: {
        invalidMobilePhone: () => t('common.validation.invalidMobilePhone'),
      },
    },
  };

  constructor() {
    super();
  }

  get templateOptions(): ISnMobilePhoneTemplateOptions {
    return this.field.templateOptions;
  }
}
